import HomePage from "../../Home"
import { Container, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import CBCotizaciones from "../CBCotizaciones"
import TClientes from "../TClientes"
import { useDispatch } from "react-redux"
import { obtenerCotizacionesReviewAction } from "../../../ducks/cotizacioensDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { useEffect } from "react"
export const styles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    marginSpace: {
        margin: "0.2rem"
    },
    filterContent: {
        margin: "0.2rem"
    }
}))

export const VCotizacionesAdmin = () => {
    const classes = styles()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerCotizacionesReviewAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Cotizaciones pendientes</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.marginSpace}>
                            <div className={classes.filterContent}>
                                <CBCotizaciones />
                            </div>
                            <TClientes />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VCotizacionesAdmin